import React from 'react';
import { Reveal } from './Reveal';
const problems = ['You finish a session but aren’t sure what you actually did or why it worked.', 'A client asks you a clinical question and you don’t have a clear answer.', 'You charge less than you’re worth because you don’t feel credible enough.', 'You have no intake form, no follow-up protocol, and no way to track client progress.', 'You want to train others but have no structure or framework to teach.', 'You help people but feel like you’re making it up as you go.', 'You secretly wonder if you’re “real enough” to call yourself a professional.'];
export function Problems() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-183" data-mp="2j6ggal6wwzyn">
      <div className="mx-auto max-w-3xl" data-id="element-184" data-mp="2f5wkpm1zm4em">
        <Reveal className="text-center" data-id="element-185" data-mp="2f6xuzob6imva">
          <h2 className="font-serif text-4xl leading-tight sm:text-5xl" data-id="element-186" data-mp="hdsbi7eme4gr">
            💫 How Many More Times Are You Going to{' '}
            <span className="text-amber" data-id="element-187" data-mp="ddzynii71c5l">Wing It?</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-188" data-mp="34ptmy1jc3dvd">
            If you’re working with energy, you’ve probably lived every one of these moments:
          </p>
        </Reveal>
        <ul className="mt-10 space-y-3" data-id="element-189" data-mp="2vqgcb5jh4j92">
          {problems.map((problem, index) => <Reveal key={problem} delay={index * 0.035} data-id="element-190" data-mp="2zrs6lodalsnl" data-mpi={index}>
              <li className="flex gap-3 rounded-xl border border-navy/10 bg-mist p-5 text-sm leading-relaxed text-slate shadow-premium sm:text-base" data-id="element-191" data-mp="2zsaan7675b62">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-amber/60 text-xs text-amber" data-id="element-192" data-mp="3sg6668k14x19">
                  ✕
                </span>
                {problem}
              </li>
            </Reveal>)}
        </ul>
        <Reveal data-id="element-193" data-mp="3iojj9eybx9io">
          <p className="mt-10 text-center font-serif text-2xl italic text-amber sm:text-3xl" data-id="element-194" data-mp="aaujwjqwqtju">
            “It’s not that you’re not skilled. You just need a system. And systems can be learned.”
          </p>
        </Reveal>
      </div>
    </section>;
}